/**
 * @fileoverview ルートレイアウト
 * @description 全ページ共通のレイアウトを定義
 */
import { createRootRoute, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'

/**
 * ルートレイアウトコンポーネント
 * @description 全ページで共有されるレイアウト（ヘッダー、フッターなど）
 */
function RootLayout() {
  return (
    <div className="min-h-screen bg-background">
      {/* メインコンテンツ */}
      <Outlet />

      {/* 開発時のみルーターデバッグツールを表示 */}
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </div>
  )
}

/**
 * ルートルート定義
 */
export const Route = createRootRoute({
  component: RootLayout,
})
